import React from 'react'
import {
  getRedirectUrl,
  getAriaLabel,
} from 'services/utils/constants/config-values'
import { bool, string, number } from 'prop-types'
import logoGreen from './images/logo-green.svg'
import logoWhite from './images/logo-white.svg'
import logoGeorge from './images/george.svg'
import logoBTC from './images/baby-club.svg'

const Logo = ({
  footer,
  isThirdParty,
  isGeorgeUser,
  isCreditCardUser,
  requestOrigin,
  tabOrder,
}) => {
  const getLogoUrl = (origin) => {
    switch (origin) {
      case 'george':
        return logoGeorge
      case 'btc':
        return logoBTC
      case 'asda':
      case 'gi':
      default:
        return logoGreen
    }
  }

  const imgElement = (<img
    src={getLogoUrl(requestOrigin)}
    alt={getAriaLabel(requestOrigin)}
  />)

  if (!footer && !isCreditCardUser) {
    return (
      <a
        id='logo'
        href={getRedirectUrl(requestOrigin)}
        target={isThirdParty ? '_blank' : '_self'}
        tabIndex={tabOrder}
        rel='noreferrer'
      >
        {imgElement}
      </a>
    )
  } else if (isCreditCardUser) {
    return imgElement
  }

  return (
    <img
      src={isGeorgeUser ? logoGeorge : logoWhite}
      alt={isGeorgeUser ? 'George' : 'Asda'}
    />
  )
}

Logo.propTypes = {
  footer: bool,
  isThirdParty: bool,
  isGeorgeUser: bool,
  isCreditCardUser: bool,
  requestOrigin: string,
  tabOrder: number,
}

Logo.defaultProps = {
  footer: false,
  isThirdParty: false,
  isGeorgeUser: false,
  isCreditCardUser: false,
  tabOrder: 0,
  requestOrigin: 'asda',
}

export default Logo
